import React, { useRef, useEffect, useState } from 'react';
import Slider from 'react-slick';
import commonUtil from '../../../../utils/commonUtil';

const channel = commonUtil.getChannel();

// Custom Arrow Components
const PrevArrow = ({ onClick }) => (
  <button
    className='slick-custom-prev slick-arrow'
    onClick={onClick}
    aria-label='Previous slide'
  >
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='32px'
      viewBox='0 -960 960 960'
      width='32px'
      fill='#434343'
    >
      <path d='M480-525 291-336l-51-51 240-240 240 240-51 51-189-189Z' />
    </svg>
  </button>
);

const NextArrow = ({ onClick }) => (
  <button
    className='slick-custom-next slick-arrow'
    onClick={onClick}
    aria-label='Next slide'
  >
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='32px'
      viewBox='0 -960 960 960'
      width='32px'
      fill='#434343'
    >
      <path d='M480-333 240-573l51-51 189 189 189-189 51 51-240 240Z' />
    </svg>
  </button>
);

const VerticalCard = ({ card, activeSlide, index, isWap }) => {
  return (
    <div
      className={`carousel-slide slide${index} ${index === activeSlide ? 'animate-up' : ''}`}
      key={index}
    >
      <div
        {...(isWap
          ? { id: 'verticalCardsSection', className: 'row verticalCardsRow' }
          : { className: 'row' })}
      >
        <div className='left-section'>
          <img
            src={card?.banner_image?.url}
            alt={card?.banner_image_title}
            className='img-responsive'
          />
        </div>
        <div className='right-section'>
          {card?.banner_image_title &&
            (isWap ? (
              <h3
                className={`banner-image-title${card?.banner_image_title == 'Paso 2' ? ' card2heading' : card?.banner_image_title == 'Paso 3' ? ' card3heading' : ''}`}
              >
                {card?.banner_image_title}
              </h3>
            ) : (
              <h3>{card?.banner_image_title}</h3>
            ))}
          {card?.banner_sub_title && (
            <p className={`title${isWap ? ' banner-sub-title' : ''}`}>
              {card?.banner_sub_title}
            </p>
          )}
          {card?.banner_description && (
            <p className={`description${isWap ? ' banner-description' : ''}`}>
              {card?.banner_description}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

const VerticalImageCarousel = ({ component, state, verticalSettings }) => {
  const sliderRef = useRef(null);
  const [activeSlide, setActiveSlide] = useState(0);

  const settings = {
    vertical: true,
    verticalSwiping: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    infinite: false,
    ...(verticalSettings ? { ...verticalSettings } : {}),
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    beforeChange: (current, next) => setActiveSlide(next),
  };

  useEffect(() => {
    // Animate only the current slide
    const slides = document.querySelectorAll('.slick-slide');
    slides.forEach((slide) => slide.classList.remove('animate-up'));
    const active = document.querySelector(
      `.slick-slide[data-index='${activeSlide}']`,
    );
    if (active) active.classList.add('animate-up');
  }, [activeSlide]);

  const classNamea = component?.section_id;
  const className = component?.section_id
    ? `section-wrapper section-padding vertical-carousel desktop-grid ${classNamea.replace(' ', '-')}`
    : `section-wrapper section-padding vertical-carousel${channel === 'wap' ? '' : ' desktop-grid'}`;
  return (
    <div className={className}>
      <div className='section-title'>
        {component?.title && <h5>{component?.title}</h5>}
        {component?.sub_title && (
          <p
            className={
              state?.user?.data?.result?.isLoggedIn ? 'logged-user-wap' : ''
            }
          >
            {component?.sub_title}
          </p>
        )}
      </div>
      <div>
        {channel === 'wap' ? (
          <>
            {component?.carousel_cards?.map((card, index) => (
              <VerticalCard
                card={card}
                activeSlide={activeSlide}
                key={index}
                index={index}
                isWap={true}
              />
            ))}
          </>
        ) : (
          <Slider
            className='wrapper slick-vertical'
            ref={sliderRef}
            {...settings}
          >
            {component?.carousel_cards?.map((card, index) => (
              <VerticalCard
                card={card}
                activeSlide={activeSlide}
                key={index}
                index={index}
              />
            ))}
          </Slider>
        )}
      </div>
    </div>
  );
};

export default VerticalImageCarousel;
